module.exports = __webpack_public_path__ + "media/application/images/icons/arrow-right-blue-1397025d8648d13764ef45f475b06bd2.svg";